export enum ScrollInViewBehaviourType {
  AUTO = 'auto',
  SMOOTH = 'smooth',
}

export enum ScrollInViewBlockType {
  CENTER = 'center',
}
